import {
  ListStoreDefault,
  ListRequestHandler,
  ListFilterHandler,
  ListSuccessHandler,
  RichEntityDataListHandler,
 } from 'js/helpers/reducers.js';
import {
  TOGGLE_ADVANCED_SEARCH,
  FETCH_ADVANCED_SEARCH_KEYWORDS,
  FETCHED_ADVANCED_SEARCH_KEYWORDS,
  SET_ADVANCED_SEARCH_KEYWORDS_FILTER,
  FETCH_ADVANCED_SEARCH_CATEGORIES,
  FETCHED_ADVANCED_SEARCH_CATEGORIES,
  SET_ADVANCED_SEARCH_CATEGORIES_FILTER,
  FETCH_ADVANCED_SEARCH_BRANDS,
  FETCHED_ADVANCED_SEARCH_BRANDS,
  SET_ADVANCED_SEARCH_BRANDS_FILTER,
  FETCH_ADVANCED_SEARCH_PUBLISHERS,
  FETCHED_ADVANCED_SEARCH_PUBLISHERS,
  SET_ADVANCED_SEARCH_PUBLISHERS_FILTER,
  UPDATE_ADVANCED_SEARCH,
  UPDATE_ADVANCED_SEARCH_DATES,
  UPDATE_ADVANCED_SEARCH_ENTITY,
  RESET_ADVANCED_SEARCH_PUBLISHERS_FILTER,
  RESET_ADVANCED_SEARCH_BRANDS_FILTER,
  RESET_ADVANCED_SEARCH_KEYWORDS_FILTER,
} from 'components/Pages/AdvancedSearch/actions.js';
import { intervalFromCustomRange } from '@bit/knotchinc.web-react-components.date-filter';

const updateAdvancedSearch = (state, action) => {
  if (action.data.field === 'content_type' && action.data.value === 'owned') {
    return Object.assign(state, {
      [action.data.field]: action.data.value,
      richPublisherData: [],
      publishersList: ListStoreDefault({
        pageNum: 1,
        pageSize: 10,
        searchBy: '',
        searchQuery: '',
      }),
    });
  }
  return Object.assign(state, { [action.data.field]: action.data.value });
};

const defaultState = {
  keywordsList: ListStoreDefault({
    pageNum: 1,
    pageSize: 10,
    searchBy: '',
    searchQuery: '',
  }),
  categoriesList: ListStoreDefault({
    pageNum: 1,
    pageSize: 10,
    searchBy: '',
    searchQuery: '',
  }),
  brandsList: ListStoreDefault({
    pageNum: 1,
    pageSize: 10,
    searchBy: '',
    searchQuery: '',
  }),
  publishersList: ListStoreDefault({
    pageNum: 1,
    pageSize: 10,
    searchBy: '',
    searchQuery: '',
  }),
  startDate: '',
  endDate: '',
  content_type: '',
  content_format: '',
  article_length: '',
  brand_ids: [],
  publisher_ids: [],
  keyword_tags: [],
  searchQuery: '',
  searchBy: '',
  isModalOpen: false,
  richBrandData: [],
  richPublisherData: [],
};

// eslint-disable-next-line complexity
const AdvancedSearchReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return Object.assign({}, defaultState);
    case TOGGLE_ADVANCED_SEARCH:
      return Object.assign(state, { isModalOpen: !state.isModalOpen });
    case FETCH_ADVANCED_SEARCH_KEYWORDS:
      return ListRequestHandler(state, action, 'keywordsList');
    case FETCHED_ADVANCED_SEARCH_KEYWORDS:
      return ListSuccessHandler(state, action, 'keywordsList');
    case SET_ADVANCED_SEARCH_KEYWORDS_FILTER:
      return ListFilterHandler(state, action, 'keywordsList');
    case RESET_ADVANCED_SEARCH_KEYWORDS_FILTER:
      return Object.assign({}, state, { keywordsList: defaultState.keywordsList });
    case FETCH_ADVANCED_SEARCH_CATEGORIES:
      return ListRequestHandler(state, action, 'categoriesList');
    case FETCHED_ADVANCED_SEARCH_CATEGORIES:
      return ListSuccessHandler(state, action, 'categoriesList');
    case SET_ADVANCED_SEARCH_CATEGORIES_FILTER:
      return ListFilterHandler(state, action, 'categoriesList');
    case FETCH_ADVANCED_SEARCH_BRANDS:
      return ListRequestHandler(state, action, 'brandsList');
    case FETCHED_ADVANCED_SEARCH_BRANDS:
      return ListSuccessHandler(state, action, 'brandsList');
    case SET_ADVANCED_SEARCH_BRANDS_FILTER:
      return ListFilterHandler(state, action, 'brandsList');
    case RESET_ADVANCED_SEARCH_BRANDS_FILTER:
      return Object.assign({}, state, { brandsList: defaultState.brandsList });
    case FETCH_ADVANCED_SEARCH_PUBLISHERS:
      return ListRequestHandler(state, action, 'publishersList');
    case FETCHED_ADVANCED_SEARCH_PUBLISHERS:
      return ListSuccessHandler(state, action, 'publishersList');
    case SET_ADVANCED_SEARCH_PUBLISHERS_FILTER:
      return ListFilterHandler(state, action, 'publishersList');
    case RESET_ADVANCED_SEARCH_PUBLISHERS_FILTER:
      return Object.assign({}, state, { publishersList: defaultState.publishersList });
    case UPDATE_ADVANCED_SEARCH:
      return updateAdvancedSearch(state, action);
    case UPDATE_ADVANCED_SEARCH_ENTITY:
      return RichEntityDataListHandler(state, action);
    case UPDATE_ADVANCED_SEARCH_DATES: {
      const data = action.data;
      const { startDate, endDate } = data;
      const dates = {
        startDate,
        endDate,
        timeInterval: intervalFromCustomRange({ startDate, endDate }),
      };
      return Object.assign(state, dates);
    }
    default:
      return Object.assign({}, state);
  }
};

export default AdvancedSearchReducer;
